import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/storage.css';
import { useAuth } from '../context/AuthContext';

function Storage() {
  const { logout, userRole } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  const handleBack = () => {
    navigate('/init');
  };

  return (
    <div className="storage-page">
      {userRole === 'admin' && (
        <button onClick={handleBack} className="storage-back-button">
          &#8592;
        </button>
      )}
      <button className="logout-button" onClick={handleLogout}>Cerrar Sesión</button>

      <div className="storage-header">
        <h2>¿Qué quieres hacer?</h2>
      </div>

      <div className="storage-button-container">
        <Link to="/storage/ingreso" className="storage-button">Ingreso de Mercadería</Link>
        <Link to="/storage/movimiento" className="storage-button">Movimiento de Mercadería</Link>
        <Link to="/storage/movimiento-recepcion" className="storage-button">Mover desde Recepción</Link>
        <Link to="/cart-free" className="storage-button liberar-button">Liberar Carrito</Link>
        <Link to="/editar-stock" className="storage-button">Edición de Stock</Link>
      </div>
    </div>
  );
}

export default Storage;
